let lastScrollTop = 0;

const setGlobalEventListeners = () => {
	window.addEventListener('scroll', (e) => {
		const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
			|| 0;
		document.body.classList.toggle('is-page-scrolled', Boolean(scrollTop));
		document.body.classList.toggle('is-whole-page-scrolled', Boolean(scrollTop > 600));
		document.body.dataset.scrollDirection = scrollTop < lastScrollTop ? 'down' : 'up';
		lastScrollTop = scrollTop;
	});
};

export default setGlobalEventListeners;
